export const getCountryName = (code: string, locale: string): string => {
	try
	{
		return new Intl.DisplayNames(
			[locale.toString().toLowerCase()],
			{
				type: 'region',
				style: 'short'
			}
		).of(code.toString().toUpperCase()) || code;
	}
	catch (e)
	{
		return code;
	}
}